function isValidEmail(token) {
    // Note: this is not a perfect regex, for example foo@bar..com will return true
    // but at least it does some simple client side validation.  The server
    // will do validation too
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return regex.test(token);
}

export default isValidEmail;
